/**
 * The errors `authenticatedFetch` throws for a 401 or 403. Kept free of React
 * and `@src` imports so jest can load them in tests of pure error mapping.
 */
export class UnauthorizedError extends Error {
  readonly kind = "http" as const;
  readonly status = 401;

  constructor(message = "Unauthorized") {
    super(message);
    this.name = "UnauthorizedError";
  }
}

export class ForbiddenError extends Error {
  readonly kind = "http" as const;
  readonly status = 403;

  constructor(message = "Forbidden") {
    super(message);
    this.name = "ForbiddenError";
  }
}
